export const environment = 
{
  "baseUrl": "https://dev.elevate-apis.shikshalokam.org/template/api/v1/",
  "customAuth": true,
  "production": true,
  "stagingURl": "https://dev.elevate-apis.shikshalokam.org/"
}
